
import Vue from 'vue'
import { Toast } from 'vant'
// v-longpress指令

let longpress = Vue.directive('longpress', {
  bind: function (el, binding, vNode) {
    if (typeof binding.value !== 'function') {
      Toast('指令绑定的值必须是一个方法！')
      return
    }
    // 定义计时器变量
    let pressTimer = null
    // 定义长按事件，触发该事件时，触发指令绑定的方法
    const start = (e) => {
      if (e.type === 'click' && e.button !== 0) {
        return
      }
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          handler()
        }, 1000)
      }
    }
    // 定义释放事件，清除计时器变量
    const cancel = (e) => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer)
        pressTimer = null
      }
    }
    // 绑定事件
    // el.addEventListener('mousedown', start)
    el.addEventListener('touchstart', start)
    el.addEventListener('click', cancel)
    // el.addEventListener('mouseout', cancel)
    el.addEventListener('touchend', cancel)
    el.addEventListener('touchcancel', cancel)
    // 执行指令绑定的方法
    const handler = (e) => {
      binding.value(e)
    }
  }
})

export default longpress



// WEBPACK FOOTER //
// ./src/utils/longPress.js